import { render } from "./RegisterButton2.vue?vue&type=template&id=0dc9a9e6&scoped=true&ts=true"
import script from "./RegisterButton2.vue?vue&type=script&lang=ts"
export * from "./RegisterButton2.vue?vue&type=script&lang=ts"

import "./RegisterButton2.vue?vue&type=style&index=0&id=0dc9a9e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc9a9e6"]])

export default __exports__